<template>
  <div class="detail-box position-header" v-loading="loading">
    <navHeader :titleList="['收藏行为客户', '收藏行为客户详情']"/>
    <div class="detail-content common-padding">
      <el-card class="box-card">
        <el-row type="flex" justify="center">
          <el-col :span="10">
            <el-form ref="form" class="add-form" :model="form" label-width="240px">
              <el-form-item label="收藏类型：">
                <el-input v-model="form.sourceType" disabled></el-input>
              </el-form-item>
              <el-form-item label="收藏名称：">
                <el-input v-model="form.name" disabled></el-input>
              </el-form-item>
              <el-form-item label="手机号：">
                <el-input v-model="form.sysUser.mobile" disabled></el-input>
              </el-form-item>
              <el-form-item label="昵称：">
                <el-input v-model="form.sysUser.nickName" disabled></el-input>
              </el-form-item>
              <el-form-item label="公司名称：">
                <el-input v-model="form.authenticationInformation.companyName" disabled></el-input>
              </el-form-item>
              <el-form-item label="联系人：">
                <el-input v-model="form.authenticationInformation.contacts" disabled></el-input>
              </el-form-item>
              <el-form-item label="职位：">
                <el-input v-model="form.authenticationInformation.position" disabled></el-input>
              </el-form-item>
            </el-form>
            <div class="info-footer">
              <el-button @click="back">返回</el-button>
            </div>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import navHeader from '../../components/navHeader.vue'

export default {
  name: 'detail',
  data () {
    return {
      loading: false,
      form: {
        sourceType: '',
        name: '',
        sysUser: {
          mobile: '',
          nickName: '',
          contactName: '',
          position: ''
        },
        companyName: '',
        authenticationInformation: {
          companyName: '',
          contacts: '',
          position: ''
        }
      }
    }
  },
  components: {
    navHeader
  },
  methods: {
    getDetail (id) {
      this.$http
        .post('/myCollect/detail', {id})
        .then((res) => {
          if (res.data.code === '200') {
            this.form = res.data.data
            this.form.authenticationInformation = res.data.data.authenticationInformation || {
              companyName: '',
              contacts: '',
              position: ''
            }
          } else {
            this.$message.error(res.data.msg)
          }
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
    },
    back () {
      this.$router.back()
    }
  },
  created () {
    if (this.$route.query.id) {
      this.loading = true
      this.getDetail(this.$route.query.id)
    } else {
      this.loading = false
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/visitInfo/detail.vue